import { Inject, Pipe, PipeTransform } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { TranslateService } from '@ngx-translate/core';
import { DI_UNIT_TRANSLATIONS_BASE_PATH, QPointTranslateUnitPipe } from './q-translate-unit.pipe';
import { IQPointNumberFormatService, injectNumberFormatService } from '../services/number-format.service';

export class ValueAndUnit {
    value: number;
    unitSign: string;
}

@Pipe({
  name: 'qPointFormatNumberAndTranslateUnit',
  standalone: true,
  pure: false
})
export class QPointFormatNumberAndTranslateUnitPipe implements PipeTransform {
  private numberFormatService: IQPointNumberFormatService = injectNumberFormatService();

  constructor(
    @Inject(DI_UNIT_TRANSLATIONS_BASE_PATH) private basePath: string,
    private translate: TranslateService,
    private intlService: IntlService) {
  }

  transform(quantity?: ValueAndUnit): string {
    if (quantity == null || quantity.value === null) {
      return null;
    }

    const translatedUnit = new QPointTranslateUnitPipe(this.basePath, this.translate).transform(quantity.unitSign) ?? '';

    const format = this.numberFormatService.formatUnit(quantity.unitSign) ?? ",0";

    const formattedNumber = this.intlService.formatNumber(quantity.value, format);

    return `${formattedNumber}\u00A0${translatedUnit}`;
  }
}
